
function setCookie(name, value, suffix) {
    const domain = window.location.hostname.split('.');
    const tld = domain.slice(-2).join('.');

    document.cookie = name + '=' + value + '; Path=/; SameSite=Lax; Domain=' + tld + ';' + suffix;
}
window.setCookie = setCookie;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
window.getCookie = getCookie;


function enableAllCookies() {
    setCookie('cookieConsent', 'True', 'Max-Age=15552000');
    closePopup();
    updateConsentSettings();
}

function rejectCookieConsent() {
    setCookie('cookieConsent', 'False', 'Max-Age=15552000');
    location.reload();
}

function manageCookies() {
    document.getElementById("cookiePopUp").style.visibility = 'visible'
}

function closePopup() {
    document.getElementById("cookiePopUp").style.visibility = 'hidden';
}


function initGTM() {
    (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
            'gtm.start':
                new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-M3GRLHZJ');

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };

    window.gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        functionality_storage: "denied",
        personalization_storage: "denied",
        wait_for_update: 250
    });
    
    //console.log("init GTM");
}

function updateConsentSettings() {
    var myCookie = getCookie("cookieConsent");

    if (myCookie == "True") {
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }

        gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
        });

        window.dataLayer.push({
            'event': 'enableCookies'
        });
    };
}


initGTM();

var myCookie = getCookie("cookieConsent");
document.getElementById("manageCookies").addEventListener("click", manageCookies);
document.getElementById("allowCookies").addEventListener("click", enableAllCookies, false);
document.getElementById("rejectCookies").addEventListener("click", rejectCookieConsent, false);

if (myCookie == null) {
    try {
        document.getElementById("cookiePopUp").style.visibility = 'visible';
    } catch (error) {
        console.error(error);
    }
}

updateConsentSettings();
